// IMPORT CSS
import './css/AddWork.css';
// IMPORT COMPONENTS
import WorkForm from './WorkForm';


export default function AddWork() {
  return (
    <section id="addWork">
      <WorkForm />
    </section>
  );
}